<template>
  <div class="abstract-card">
    <div class="header">
      <div class="title d-flex justify-content-between">{{$t('components.abstract.tabs.abstractDetailSettings.abstractTitle')}}</div>
      <span>{{$t('components.abstract.tabs.abstractDetailSettings.abstractTitleMsg')}}</span>
    </div>
    <el-row :gutter="10">
      <el-col :span="12">
        <div class="registerform-input-container mt-2">
          <div class="title">
            <div>
              <label>{{$t('components.abstract.tabs.abstractDetailSettings.title')}}</label>
              <el-tooltip content="Content" placement="bottom">
                <i class="el-icon-info"></i>
              </el-tooltip>
            </div>
          </div>
          <el-input v-model="form.detailSettings.title"></el-input>
          <span class="error">{{ $errorMessage('detailSettings.Title', validationErrors) }}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="registerform-input-container mt-2">
          <div class="title">
            <div>
              <label>{{$t('components.abstract.tabs.abstractDetailSettings.maxWordLimit')}}</label>
              <el-tooltip content="Content" placement="bottom">
                <i class="el-icon-info"></i>
              </el-tooltip>
            </div>
          </div>
          <el-input-number class="w-100" v-model="form.detailSettings.maxWordLimit"></el-input-number>
          <span class="error">{{ $errorMessage('detailSettings.MaxWordLimit', validationErrors) }}</span>
        </div>
      </el-col>
      <el-col :span="24" class="mt-3" v-if="form.generalSettings.type == 1">
        <div class="custom-set-container" :class="form.detailSettings.enableKeywords ? 'sactive' : ''">
          <div class="custom-set-inner">
            <i class="fa" :class="form.enableKeywords ? 'fa-tags' : 'fa-tags'"></i>
            <div class="custom-set-info">
              <label>
                {{$t('components.abstract.tabs.abstractDetailSettings.keywords')}}
                <el-tooltip content="Content" placement="bottom">
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </label>
              <span>{{$t('components.abstract.tabs.abstractDetailSettings.keywordsMsg')}}</span>
            </div>
          </div>
          <div class="custom-set-actions fend">
            <el-switch v-model="form.detailSettings.enableKeywords"></el-switch>
          </div>
          <div class="custom-set-actions fcenter mt-3" v-show="form.detailSettings.enableKeywords">
            <el-row :gutter="10" class="w-100">
              <el-col :span="12">
                <div class="registerform-input-container mt-2">
                  <div class="title">
                    <div>
                      <label>{{$t('components.abstract.tabs.abstractDetailSettings.title')}}</label>
                      <el-tooltip content="Content" placement="bottom">
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </div>
                  </div>
                  <el-input v-model="form.detailSettings.keywordsTitle"></el-input>
                  <span class="error">{{ $errorMessage('detailSettings.keywordsTitle', validationErrors) }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="registerform-input-container mt-2">
                  <div class="title">
                    <div>
                      <label>{{$t('components.abstract.tabs.abstractDetailSettings.limit')}}</label>
                      <el-tooltip content="Content" placement="bottom">
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </div>
                  </div>
                  <el-input-number :min="1" class="w-100" v-model="form.detailSettings.keywordLimit"></el-input-number>
                  <span class="error">{{ $errorMessage('detailSettings.keywordLimit', validationErrors) }}</span>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
      <el-col :span="24" class="mt-3">
        <div class="custom-set-container" :class="form.detailSettings.enableReferences ? 'sactive' : ''">
          <div class="custom-set-inner">
            <i class="fa" :class="form.enableReferences ? 'fa-tags' : 'fa-tags'"></i>
            <div class="custom-set-info">
              <label>
                {{$t('components.abstract.tabs.abstractDetailSettings.references')}}
                <el-tooltip content="Content" placement="bottom">
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </label>
              <span>{{$t('components.abstract.tabs.abstractDetailSettings.referencesMsg')}}</span>
            </div>
          </div>
          <div class="custom-set-actions fend">
            <el-switch v-model="form.detailSettings.enableReferences"></el-switch>
          </div>
          <div class="custom-set-actions fcenter mt-3" v-show="form.detailSettings.enableReferences">
            <el-row :gutter="10" class="w-100">
              <el-col :span="12">
                <div class="registerform-input-container mt-2">
                  <div class="title">
                    <div>
                      <label>{{$t('components.abstract.tabs.abstractDetailSettings.title')}}</label>
                      <el-tooltip content="Content" placement="bottom">
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </div>
                  </div>
                  <el-input v-model="form.detailSettings.referencesTitle"></el-input>
                  <span class="error">{{ $errorMessage('detailSettings.ReferencesTitle', validationErrors) }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="registerform-input-container mt-2">
                  <div class="title">
                    <div>
                      <label>{{$t('components.abstract.tabs.abstractDetailSettings.limit')}}</label>
                      <el-tooltip content="Content" placement="bottom">
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </div>
                  </div>
                  <el-input-number :min="1" class="w-100" v-model="form.detailSettings.referencesLimit"></el-input-number>
                  <span class="error">{{ $errorMessage('detailSettings.ReferencesLimit', validationErrors) }}</span>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="bottom mt-3 d-flex justify-content-end">
      <el-button type="primary" size="mini" round :loading="loading" @click="saveAbstractDetailSettings">{{$t('components.abstract.tabs.abstractDetailSettings.save')}}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      validationErrors: [],
      loading: false,
      timeout: null,
      form: {},
    };
  },
  methods: {
    async saveAbstractDetailSettings() {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.loading = true;
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch('abstractUpdateDetailSettings', this.form);

        this.validationErrors = res.data.validationErrors;
        this.loading = false;
      }, 500);
    },
  },
  created() {
    if (this.data != undefined && this.data != null) {
      this.form = this.data;
    }
  },
  watch: {
    data: function() {
      if (this.data != undefined && this.data != null) {
        this.form = this.data;
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/abstract/tabs/AbstractDetailSettings.vue